import { FormControl, InputAdornment, InputLabel, LinearProgress, MenuItem, Paper, Select, TextField } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import { format, parse } from 'date-fns';
import React from 'react';
import DividasEmAbertoService from '../../services/DividasEmAbertoService';
import DividaServDesligadoService from '../../services/DividaServDesligadoService';
import ProcessoService from '../../services/ProcessoService';
import FilterBeneficiario from '../share/FilterBeneficiario';
import IntegrationAutosuggest from '../share/IntegrationAutosuggest';
import Utils from '../share/Utils';
import VariantSnackbar from '../share/VariantSnackbar';

const styles = theme => ({
  paper: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
  },
  body: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  formControlAutoCompleteBenef: {
    margin: theme.spacing.unit,
    minWidth: 400,
  },
  formControlValor: {
    margin: theme.spacing.unit,
    marginLeft: theme.spacing.unit * 3,
    width: 220,
  },
  selectAnoProcesso: {
    width: 140,
    marginTop: theme.spacing.unit * 0.5,
    marginBottom: theme.spacing.unit * 0.5,
    marginLeft: theme.spacing.unit * 2,
  },
  textFieldNumProcesso: {
    width: 140,
    marginLeft: theme.spacing.unit,
    margin: theme.spacing.unit * -1.5,
  },
  selectEvento: {
    margin: theme.spacing.unit,
    marginLeft: theme.spacing.unit * 3,
    width: 250,
  },
  selectTipo: {
    margin: theme.spacing.unit,
    marginLeft: theme.spacing.unit * 3,
    width: 450,
  },
  formControlObservacao: {
    margin: theme.spacing.unit,
    marginLeft: theme.spacing.unit * 3,
    width: 830,
  },
  formControlValorInfo: {
    margin: theme.spacing.unit,
    marginLeft: theme.spacing.unit * 3,
    width: 255,
  },
  textFieldDtaCadastro: {
    marginBottom: theme.spacing.unit,
    marginLeft: theme.spacing.unit * 3,
    width: 232,
    marginRight: theme.spacing.unit,
  },
  textFieldTxtCodigoSei: {
    width: 200,
    margin: theme.spacing.unit,
    marginLeft: theme.spacing.unit * 2,
    marginTop: theme.spacing.unit * 0.5,
    marginBottom: theme.spacing.unit * 0.5,
  },
});
class FormDialogDividaServDesligado extends React.Component {
  utils = new Utils();
  processoService = new ProcessoService();
  dividaServDesligadoService = new DividaServDesligadoService();
  dividasEmAbertoService = new DividasEmAbertoService();
  constructor (props) {
    super(props);
    this.state = {
      ...this.props.divida,
      fetchingValor: false,
      fetchingProcessos: false,
      nomesBeneficiarios: this.props.nomesBeneficiarios,
      processos: [],
      snackOpen: false,
      snackMessage: '',
      errorMessageValor: '',
      dividaSelected: {},
      dividaEmAberto: 0,
      valDividaOriginal: 0,
      errorMessageData: '',
    };
    this.state.valDivida = this.state.valDivida === undefined ? '' : this.state.valDivida;
    this.state.valDividaOriginal = this.state.valDivida;
    this.state.dtaCadastro = format(parse(this.state.dtaCadastro), 'YYYY-MM-DD');
  }

  handleCloseSnackbar = async () => {
    this.setState({ snackOpen: false });
    // await this.props.handleSave(this.state.dividaSelected);
  };

  componentDidMount = async () => {
    if (this.props.divida.anoProcesso !== undefined && this.props.divida.anoProcesso !== null) {
      await this.consultarProcessos(this.props.divida.anoProcesso);
    }
  }

  consultarProcessos = async (ano) => {
    let processos = await this.processoService.consultarProcessos(ano);
    this.setState({processos: processos});
  }

  handleClickLimpar = async () => {
    this.setState({
      numMatricula: '',
      nomeBeneficiario: ''
    });
  }

  handleSelectBeneficiario = async (carteira, nome) => {
    this.setState({
      numMatricula: carteira,
      nomeBeneficiario: nome
    });
    if (carteira !== '' && this.state.codEvento === 2) {
      if (this.props.modoInclusao) {
        this.setState({fetchingValor: true});
        let dividaEmAberto = await this.dividasEmAbertoService.consultarDividaPorCarteira(carteira)
        const nf = new Intl.NumberFormat('pt-BR', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        this.setState({dividaEmAberto: nf.format(dividaEmAberto), valDivida: nf.format(dividaEmAberto), fetchingValor: false});
      } else {
        this.setState({valDivida: this.state.valDividaOriginal, fetchingValor: false});
      }
    }
  }

  handleBlurValor = () => {
    if (this.state.valDivida === '' || this.state.valDivida === null || this.state.valDivida === undefined) {
      this.setState({errorMessageValor: 'Favor preencher o valor'});
    }
    if (this.state.codEvento === 3 && Number(this.state.valDivida.replace('.', '').replace(',', '.')) >= 0) {
      this.setState({errorMessageValor: 'O valor deve ser menor que zero'});
    }
  }
  handleChangeTextField = event => {
    var valorNovo = '';
    if (event.target.name === 'valDivida') {
      valorNovo = event.target.value !== '' ? this.utils.formataValorNegativo(event.target.value, event.target.defaultValue) : '';
      this.setState({ [event.target.name]: valorNovo, errorMessageValor: '' });
    }
    if (event.target.name === 'txtProcessoSei') {
      this.setState({ [event.target.name]: event.target.value.toUpperCase() });
    }
  };
  handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }
  handleBlurData = event => {
    if (this.state.dtaCadastro === null ||
      this.state.dtaCadastro === undefined ||
      this.state.dtaCadastro === 'Invalid Date' ||
      this.state.dtaCadastro === '') {
      this.setState({errorMessageData: 'Favor preencher a data'});
    } else {
      this.setState({errorMessageData: ''});
    }
  }
  handleChangeEvento = async (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
    this.setState({fetchingValor: true});
    if (event.target.value === 1) {
      if (!this.props.modoInclusao) {
        this.setState({valDivida: this.state.valDividaOriginal, fetchingValor: false});
      } else {
        this.setState({valDivida: '', fetchingValor: false});
      }
    }
    if (event.target.value === 2) {
      if (this.props.modoInclusao) {
        let dividaEmAberto = await this.dividasEmAbertoService.consultarDividaPorCarteira(this.state.numMatricula)
        const nf = new Intl.NumberFormat('pt-BR', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        this.setState({dividaEmAberto: nf.format(dividaEmAberto), valDivida: nf.format(dividaEmAberto), fetchingValor: false});
      } else {
        this.setState({valDivida: this.state.valDividaOriginal, fetchingValor: false});
      }
    }
    if (event.target.value === 3) {
      if (!this.props.modoInclusao) {
        this.setState({valDivida: this.state.valDividaOriginal, fetchingValor: false});
      } else {
        if (this.state.valDivida >= 0) {
          this.setState({valDivida: '', fetchingValor: false});
        } else {
          this.setState({fetchingValor: false});
        }
      }
    }
  }
  handleChangeSelectAnoProcesso = async event => {
    this.setState({fetchingProcessos: true, numProcesso: ''});
    if (event.target.value !== 0) {
      let processos = await this.processoService.consultarProcessos(event.target.value);
      this.setState({ processos: processos });
    } else {
      await this.processoService.consultarAnosProcessos();
    }
    this.setState({anoProcesso: event.target.value, fetchingProcessos: false});
  }
  getSuggestionValueNumProcesso = (suggestion, id) => {
    if (suggestion.nome !== undefined) {
      this.setState({numProcesso: Number(suggestion.nome)});
    }
    if (suggestion === '' && id === 0) {
      this.setState({numProcesso: undefined});
    }
    return suggestion.nome;
  }
  handleChangeObservacao = event => {
    var novoValor = event.target.value;
    this.setState({ [event.target.name]: novoValor.toUpperCase() });
  };

  isSalvarDisabled = () => {
    return (this.state.errorMessageValor !== '' ||
    this.state.valDivida === undefined ||
    this.state.valDivida === 0 ||
    this.state.valDivida === '0,00' ||
    this.state.valDivida === '') ||

    (this.state.nomeBeneficiario === '' ||
     this.state.nomeBeneficiario === undefined) ||

     (this.state.codEvento === 0 ||
     this.state.codEvento === undefined) ||

     (this.state.codTipo === 0 ||
     this.state.codTipo === undefined) ||

     (this.state.errorMessageData !== '' ||
     this.state.dtaCadastro === undefined ||
     this.state.dtaCadastro === 'Invalid Date' ||
     this.state.dtaCadastro === '');
  }

  handleClickSave = async () => {
    const divida = {
      numDivida: this.state.numDivida === undefined ? 0 : this.state.numDivida,
      seqBeneficiario: this.state.seqBeneficiario === undefined ? 0 : this.state.seqBeneficiario,
      seqDependente: this.state.seqDependente === undefined ? 0 : this.state.seqDependente,
      numMatricula: this.state.numMatricula,
      nomeBeneficiario: '',
      valDivida: this.state.valDivida.replace('.', '').replace(',', '.'),
      codEvento: this.state.codEvento === undefined ? 2 : this.state.codEvento,
      desEvento: '',
      codTipo: this.state.codTipo === undefined ? 0 : this.state.codTipo,
      desTipo: '',
      dtaCadastro: this.state.dtaCadastro === undefined ? null : this.state.dtaCadastro,
      txtObservacao: this.state.txtObservacao === undefined ? '' : this.state.txtObservacao,
      numProcesso: this.state.numProcesso === undefined ? 0 : this.state.numProcesso,
      anoProcesso: this.state.anoProcesso === undefined ? 0 : this.state.anoProcesso,
      txtProcessoSei: this.state.txtProcessoSei === undefined || this.state.txtProcessoSei === null ? '' : this.state.txtProcessoSei,
    };
    var errorMessage = '';
    errorMessage = await this.dividaServDesligadoService.validarDivida(divida);
    if (errorMessage.data === '' || errorMessage.data === undefined) {
      await this.props.handleSave(divida);
    } else {
      this.setState({snackOpen: true, snackMessage: errorMessage.data, dividaSelected: divida});
    }
  }
  render () {
    const { classes, open, handleClose, titulo } = this.props;
    return (
      <div>
        <Dialog
          disableBackdropClick
          maxWidth='md'
          fullWidth
          open={open}
          onClose={handleClose}
        >
          <DialogTitle>
            {titulo}
          </DialogTitle>
          <DialogContent>
            <Paper className={classes.body} elevation={1}>
              <FormControl component='filedset' className={classes.formControlAutoCompleteBenef}>
                <FilterBeneficiario
                  beneficiarios={this.props.nomesBeneficiarios}
                  disabled={!this.props.isEditavel}
                  nomeInicial={this.state.nomeBeneficiario}
                  carteiraInicial={this.state.numMatricula}
                  handleSelectBeneficiario={this.handleSelectBeneficiario}
                  handleClickLimpar={this.handleClickLimpar} />
              </FormControl>
              <FormControl>
                <InputLabel shrink htmlFor='tipo-simple' className={classes.selectEvento}>
                  Evento
                </InputLabel>
                <Select
                  disabled={(!this.props.isEditavel) || (this.state.nomeBeneficiario === '' || this.state.nomeBeneficiario === undefined)}
                  className={classes.selectEvento}
                  value={this.state.codEvento}
                  onChange={this.handleChangeEvento}
                  inputProps={{
                    name: 'codEvento',
                  }}
                >
                  {this.props.eventos.map((evento, idx) => {
                    return (<MenuItem key={idx} value={evento.id}>{evento.nome}</MenuItem>);
                  })}
                </Select>
              </FormControl>
              <FormControl>
                <InputLabel shrink htmlFor='tipo-simple' className={classes.selectTipo}>
                  Tipo
                </InputLabel>
                <Select
                  disabled={!this.props.isEditavel}
                  className={classes.selectTipo}
                  value={this.state.codTipo}
                  onChange={this.handleChange}
                  inputProps={{
                    name: 'codTipo',
                  }}
                >
                  {this.props.tipos.map((tipo, idx) => {
                    return (<MenuItem key={idx} value={tipo.id}>{tipo.nome}</MenuItem>);
                  })}
                </Select>
              </FormControl>
              <FormControl className={classes.formControlValor}>
              {this.state.fetchingValor ? <LinearProgress color='primary' />
                : <TextField
                  value={this.state.valDivida === null ? '0,00' : this.utils.formataValorNegativo(this.state.valDivida)}
                  disabled={!this.props.isEditavel}
                  margin='dense'
                  id='valDivida'
                  name='valDivida'
                  error={this.state.errorMessageValor !== ''}
                  label={this.state.errorMessageValor !== '' ? this.state.errorMessageValor : 'Valor Dívida'}
                  fullWidth
                  onChange={this.handleChangeTextField}
                  onBlur={this.handleBlurValor}
                  InputProps={{
                    startAdornment: <InputAdornment position='start'>R$</InputAdornment>
                  }}
                />}
              </FormControl>
              <FormControl style={{display: 'none'}}>
                <InputLabel shrink htmlFor='tipo-simple' className={classes.selectAnoProcesso}>
                  Ano Processo
                </InputLabel>
                <Select
                  className={classes.selectAnoProcesso}
                  disabled={!this.props.isEditavel}
                  value={this.state.anoProcesso}
                  onChange={this.handleChangeSelectAnoProcesso}
                  inputProps={{
                    name: 'anoProcesso',
                  }}
                >
                  <MenuItem key={0} value={0}>{''}</MenuItem>
                  {this.props.anosProcessos.map((ano, idx) => {
                    return (<MenuItem key={idx + 1} value={ano}>{ano}</MenuItem>);
                  })}
                </Select>
              </FormControl>
              <FormControl className={classes.textFieldNumProcesso} style={{display: 'none'}}>
                {this.state.fetchingProcessos ? <LinearProgress color='primary' />
                  : <IntegrationAutosuggest
                    disabled={this.state.anoProcesso === null || this.state.anoProcesso === undefined || this.state.anoProcesso === 0 || !this.props.isEditavel}
                    getSuggestionValue={this.getSuggestionValueNumProcesso}
                    suggestions={this.state.processos}
                    idSelected={this.state.anoProcesso === null || this.state.anoProcesso === undefined ? 0 : this.state.anoProcesso}
                    nomeSelected={this.state.numProcesso === null || this.state.numProcesso === undefined || this.state.numProcesso === 0 ? '' : this.state.numProcesso.toString()}
                    maxSuggestions={3}
                    label={'Número Processo'} />}
              </FormControl>
              <FormControl>
                <TextField
                  id='date'
                  disabled={!this.props.isEditavel}
                  error={this.state.errorMessageData !== ''}
                  label={this.state.errorMessageData !== '' ? this.state.errorMessageData : 'Data Dívida'}
                  type='date'
                  value={this.state.dtaCadastro}
                  onChange={this.handleChange}
                  onBlur={this.handleBlurData}
                  inputProps={{
                    name: 'dtaCadastro',
                  }}
                  className={classes.textFieldDtaCadastro}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </FormControl>
              <FormControl>
                  <TextField
                    id='txtProcessoSei'
                    name='txtProcessoSei'
                    value={this.state.txtProcessoSei}
                    margin='dense'
                    fullWidth
                    style={{maxlength: '40'}}
                    disabled={!this.props.isEditavel}
                    onChange={this.handleChangeTextField}
                    className={classes.textFieldTxtCodigoSei}
                    label={'Processo SEI'}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </FormControl>
              <FormControl className={classes.formControlObservacao}>
                <TextField
                  value={this.state.txtObservacao === null ? '' : this.state.txtObservacao}
                  margin='dense'
                  disabled={!this.props.isEditavel}
                  id='txtObservacao'
                  name='txtObservacao'
                  label='Observação'
                  fullWidth
                  onChange={this.handleChangeObservacao}
                  multiline
                  style={{maxlength: '1000'}}
                  rowsMax='10'
                  helperText='(max. 1.000 caracteres)'
                />
              </FormControl>
            </Paper>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color='primary' id={'fechar'}>
              Fechar
            </Button>
            <Button
              disabled={this.isSalvarDisabled() || !this.props.isEditavel}
              onClick={this.handleClickSave}
              color='primary'>
              Salvar
            </Button>
          </DialogActions>
        </Dialog>
        <VariantSnackbar
          vertical={'top'}
          horizontal={'right'}
          variant={this.state.sucesso ? 'success' : 'error'}
          message={this.state.snackMessage}
          open={this.state.snackOpen}
          handleClose={this.handleCloseSnackbar} />
      </div>
    );
  }
}
export default withStyles(styles)(FormDialogDividaServDesligado);
